export const convertNumberToOrdinal = (n: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  const suffix = v >= 11 && v <= 13 ? 'th' : suffixes[n % 10] ?? 'th';
  return `${n}${suffix}`;
};
